/* Homepage scripts shared by every bjh-* section (linked from snippets/bjh-styles.liquid; runs once).

   Quick add on product cards (snippets/bjh-card.liquid):
   - "Add to Cart" submits the card's .product_form. The theme's ajax cart (assets/app.js listens for
     submit on .product_form) adds the item and opens the slide-out cart.
   - "Choose Option" opens the size buttons over the image. Picking a value in every option selects
     the matching variant; sold-out combinations are crossed out and can't be added. */
(function () {
  if (window.bjhHomeJs) return;
  window.bjhHomeJs = true;

  function variantsOf(form) {
    if (form._bjhVariants) return form._bjhVariants;
    var el = form.querySelector('[data-bjh-qa-variants]');
    try { form._bjhVariants = JSON.parse(el ? el.textContent : '[]'); } catch (e) { form._bjhVariants = []; }
    return form._bjhVariants;
  }

  function chosen(form) {
    var picks = [];
    [].forEach.call(form.querySelectorAll('.bjh-qa__chip[aria-pressed="true"]'), function (chip) {
      picks[+chip.getAttribute('data-index')] = chip.getAttribute('data-value');
    });
    return picks;
  }

  /* Cross out values that can't be bought with the other options already picked, and set the variant id. */
  function update(form) {
    var variants = variantsOf(form);
    var picks = chosen(form);
    var groups = form.querySelectorAll('.bjh-qa__opt').length;
    [].forEach.call(form.querySelectorAll('.bjh-qa__chip'), function (chip) {
      var i = +chip.getAttribute('data-index');
      var value = chip.getAttribute('data-value');
      var ok = variants.some(function (v) {
        if (!v[1] || v[2][i] !== value) return false;
        for (var n = 0; n < groups; n++) if (n !== i && picks[n] != null && v[2][n] !== picks[n]) return false;
        return true;
      });
      chip.classList.toggle('is-out', !ok);
      chip.setAttribute('aria-disabled', ok ? 'false' : 'true');
    });
    var match = null;
    if (picks.filter(function (p) { return p != null; }).length === groups) {
      match = variants.filter(function (v) { return v[2].every(function (o, n) { return o === picks[n]; }); })[0] || null;
    }
    var idInput = form.querySelector('[data-bjh-qa-id]');
    var add = form.querySelector('.bjh-qa__add');
    var ready = !!(match && match[1]);
    if (idInput) idInput.value = ready ? match[0] : '';
    if (add) add.disabled = !ready;
  }

  function setOpen(form, open) {
    var panel = form.querySelector('[data-bjh-qa-panel]');
    var opener = form.querySelector('[data-bjh-qa-open]');
    if (!panel) return;
    panel.hidden = !open;
    form.classList.toggle('is-open', open);
    if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      /* An option with only one value (e.g. one color) is picked for the shopper */
      [].forEach.call(panel.querySelectorAll('.bjh-qa__chips'), function (g) {
        var chips = g.querySelectorAll('.bjh-qa__chip');
        if (chips.length === 1) chips[0].setAttribute('aria-pressed', 'true');
      });
      update(form);
      var first = panel.querySelector('.bjh-qa__chip:not(.is-out)');
      if (first) first.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var opener = t.closest('[data-bjh-qa-open]');
    if (opener) { e.preventDefault(); setOpen(opener.form || opener.closest('form'), true); return; }
    var close = t.closest('[data-bjh-qa-close]');
    if (close) { e.preventDefault(); var f = close.closest('form'); setOpen(f, false); var o = f.querySelector('[data-bjh-qa-open]'); if (o) o.focus(); return; }
    var chip = t.closest('.bjh-qa__chip');
    if (chip) {
      e.preventDefault();
      if (chip.classList.contains('is-out')) return;
      var form = chip.closest('form');
      var i = chip.getAttribute('data-index');
      var was = chip.getAttribute('aria-pressed') === 'true';
      [].forEach.call(form.querySelectorAll('.bjh-qa__chip[data-index="' + i + '"]'), function (c) { c.setAttribute('aria-pressed', 'false'); });
      chip.setAttribute('aria-pressed', was ? 'false' : 'true');
      update(form);
      return;
    }
    /* Clicking anywhere else closes any open option panel */
    [].forEach.call(document.querySelectorAll('[data-bjh-qa].is-open'), function (f) { if (!f.contains(t)) setOpen(f, false); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    [].forEach.call(document.querySelectorAll('[data-bjh-qa].is-open'), function (f) { setOpen(f, false); });
  });

  /* Stop a half-picked form from posting; close the panel once the theme has taken the item. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-bjh-qa]')) return;
    var id = form.querySelector('input[name="id"]');
    if (!id || !id.value) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    setTimeout(function () { setOpen(form, false); }, 1200);
  }, true);
})();
